export const PUBG_MOBILE_GAME_ID = 1;
export const MLBB_GAME_ID = 3;

export const GAME_SLUGS = {
    [PUBG_MOBILE_GAME_ID]: 'pubg-mobile',
    [MLBB_GAME_ID]: 'mlbb',
}

export const GAME_NAMES = {
    [PUBG_MOBILE_GAME_ID]: 'PubgMobile',
    [MLBB_GAME_ID]: 'Mlbb',
}

export const GAME_IDS = Object.keys(GAME_SLUGS).map(Number);
